"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewToggle = exports.View = exports.TableSearch = exports.Controls = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ToggleGroup = require("../ToggleGroup");
var _Icons = require("../Icons");
var _Search = require("../Search");
var _classnames = _interopRequireDefault(require("classnames"));
var _ControlsModule = _interopRequireDefault(require("./Controls.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/************************
 * Controls
 *
 * Wraps all controls for the table - search, view toggle, etc.
 * Effectively just wraps them in a flexbox and aligns them.
 ***********************/

var Controls = exports.Controls = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  var className = _ref.className,
    children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_ControlsModule.default.Container, className),
    ref: ref
  }, children);
});

/************************
 * View toggle
 ***********************/
var View = exports.View = /*#__PURE__*/function (View) {
  View["TABLE"] = "table";
  View["GRID"] = "grid";
  return View;
}({});
var VIEW_OPTIONS = [{
  key: View.TABLE,
  icon: /*#__PURE__*/_react.default.createElement(_Icons.IconRows3, {
    isFilled: true
  })
}, {
  key: View.GRID,
  icon: /*#__PURE__*/_react.default.createElement(_Icons.IconGrid1, {
    isFilled: true
  })
}];
var ViewToggle = exports.ViewToggle = /*#__PURE__*/(0, _react.forwardRef)((_ref2, ref) => {
  var className = _ref2.className,
    onChange = _ref2.onChange,
    view = _ref2.view;
  return /*#__PURE__*/_react.default.createElement(_ToggleGroup.ToggleGroup, {
    ref: ref,
    className: (0, _classnames.default)(_ControlsModule.default.Toggle, className),
    selection: view,
    selectionType: 'single',
    onSelectionChange: onChange,
    options: VIEW_OPTIONS,
    variant: 'minimal',
    isRequired: true
  });
});

/************************
 * Search
 ***********************/

var TableSearch = props => {
  return /*#__PURE__*/_react.default.createElement(_Search.Search, _extends({}, props, {
    className: (0, _classnames.default)(_ControlsModule.default.Search, props.className)
  }));
};
exports.TableSearch = TableSearch;
//# sourceMappingURL=Controls.js.map